import { assetQuery, sanityFetch } from '../services/sanity';
// ---------- FUNCTIONS ----------
export const getGlossaryTerms = async (config) => {
    const terms = await sanityFetch(config, `*[
      _type == "glossary"
      && !(_id in path("drafts.**"))
    ]${glossaryTermQuery}`);
    return terms;
};
// ---------- QUERIES ----------
export const glossaryTermQuery = `{
  _id,
  title,
  description,
  image ${assetQuery}
}`;
//# sourceMappingURL=glossary.js.map